// extracted by mini-css-extract-plugin
module.exports = {"EditButton":"style_EditButton__3cLO4","text":"style_text__G72Ih"};